module.exports = __webpack_public_path__ + "img/nr.a54cac9f.svg";